module.exports = "img/flags/GU.192f08e.png";